import {SearchEntity, SearchModel, SearchModelAdapter} from '../entity/search.models';
import {ResponseItemModel} from '../../../../../../../../core';

export class UpdateResponse extends ResponseItemModel<SearchModel> {
}

export class UpdateResponseAdapter extends ResponseItemModel<SearchEntity> {
  constructor(response: UpdateResponse) {
    super();
    this.code = response.code;
    this.extMsg = response.extMsg;
    this.field = response.field;
    this.htmlCode = response.htmlCode;
    this.msg = response.msg;
    this.msgKey = response.msgKey;
    this.rows = response.rows;
    this.value = response.value;
    this.data = new SearchModelAdapter(response.data);
  }
}
